import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		edit: {
			panel: {
				width: '50%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		select: {
			panel: {
				width: '80%',
				height: '80%'
			},
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					name: {},
					name_short: {},
					address: {},
					responsible_person: {},
					active: {},
					description: {
						config: {
							visible: false
						}
					}
				}
			}
		}
	}
};

